export const GLOBAL_DESIGN_TRANSLATION_KEYS = {
  MIXED: 'globalDesign_mixed',
  LOADING: 'globalDesign_loading',
  LOAD_ERROR: 'globalDesign_styles_load_error',
  COLOR_PICKER_TOOLTIP: 'globalDesign_color_picker_tooltip',
  STYLE_TOOLTIP: 'globalDesign_style_tooltip',
  SHADOW_BLUR_LABEL: 'globalDesign.blur.controller.label',
  SHADOW_BLUR_MIXED_LABEL: 'globalDesign.blur_mixed.controller.label',
  SHADOW_SIZE_LABEL: 'globalDesign.size.controller.label',
  SHADOW_SIZE_MIXED_LABEL: 'globalDesign.size_mixed.controller.label',
  SHADOW_COLOR_LABEL: 'globalDesign.color_and_opacity.controller.label',
  SHADOW_POSITION_LABEL: 'globalDesign.position.controller.label',
  BORDERS_LABEL: 'globalDesign_borders_label',
};

export const TRANSLATIONS = {
  TEXT_STYLE: 'globalDesign_text_style_label',
  FONT_LABEL: 'globalDesign_font_label',
  SIZE_LABEL: 'globalDesign_font_size_label',
  COLOR_PICKER_TOOLTIP: 'globalDesign_color_picker_tooltip',
  THEME_LABEL: 'globalDesign_font_theme_label',
  WEIGHT: 'globalDesign_font_weight_label',
  CUSTOM_STYLE: 'globalDesign_text_style_custom',
  SELECT_FONT: 'globalDesign_select_font',
  FONT_WEIGHT_THIN: 'globalDesign_font_weight_thin',
  FONT_WEIGHT_EXTRA_LIGHT: 'globalDesign_font_weight_extraLight',
  FONT_WEIGHT_LIGHT: 'globalDesign_font_weight_light',
  FONT_WEIGHT_REGULAR: 'globalDesign_font_weight_regular',
  FONT_WEIGHT_MEDIUM: 'globalDesign_font_weight_medium',
  FONT_WEIGHT_SEMI_BOLD: 'globalDesign_font_weight_semiBold',
  FONT_WEIGHT_BOLD: 'globalDesign_font_weight_bold',
  FONT_WEIGHT_EXTRA_BOLD: 'globalDesign_font_weight_extraBold',
  FONT_WEIGHT_BLACK: 'globalDesign_font_weight_black',
  BOLD: 'globalDesign_font_weight_bold',
  ITALIC: 'globalDesign_text_italic_label',
  UNDERLINE: 'globalDesign_text_underline_label',
  STRIKETHROUGH: 'globalDesign_text_strikethrough_label',
};

export const WEIGHT_LABELS: Record<string, string> = {
  '100': TRANSLATIONS.FONT_WEIGHT_THIN,
  '200': TRANSLATIONS.FONT_WEIGHT_EXTRA_LIGHT,
  '300': TRANSLATIONS.FONT_WEIGHT_LIGHT,
  '400': TRANSLATIONS.FONT_WEIGHT_REGULAR,
  '500': TRANSLATIONS.FONT_WEIGHT_MEDIUM,
  '600': TRANSLATIONS.FONT_WEIGHT_SEMI_BOLD,
  '700': TRANSLATIONS.FONT_WEIGHT_BOLD,
  '800': TRANSLATIONS.FONT_WEIGHT_EXTRA_BOLD,
  '900': TRANSLATIONS.FONT_WEIGHT_BLACK,
  normal: TRANSLATIONS.FONT_WEIGHT_REGULAR,
  bold: TRANSLATIONS.FONT_WEIGHT_BOLD,
};

export const GD_DATA_HOOKS = {
  // Border
  BORDER_COLOR: 'gd-border-color',
  BORDER_WIDTH: 'gd-border-width',
  BORDER_STYLE: 'gd-border-style',

  // Corner
  CORNER_TOGGLE: 'gd-corner-toggle',
  CORNER_RADIUS: 'gd-corner-radius',
  cornerByKey: (key: string) => `gd-corner-${key}`,

  // Text
  TEXT_STYLE: 'gd-text-style',
  TEXT_FONT_FAMILY: 'gd-text-font-family',
  TEXT_FONT_WEIGHT: 'gd-text-font-weight',
  TEXT_FONT_SIZE: 'gd-text-font-size',
  TEXT_COLOR: 'gd-text-color',
  TEXT_BOLD: 'gd-text-bold',
  TEXT_ITALIC: 'gd-text-italic',
  TEXT_UNDERLINE: 'gd-text-underline',
  TEXT_STRIKETHROUGH: 'gd-text-strikethrough',

  // Shadow
  SHADOW_BLUR: 'gd-shadow-blur',
  SHADOW_SPREAD: 'gd-shadow-spread',
  SHADOW_COLOR: 'gd-shadow-color',
  SHADOW_OFFSET_X: 'gd-shadow-offset-x',
  SHADOW_OFFSET_Y: 'gd-shadow-offset-y',

  // Filter
  FILTER_BLUR: 'gd-filter-blur',

  // Spacing
  SPACING_PADDING: 'gd-spacing-padding',
  SPACING_GAP: 'gd-spacing-gap',

  // Stroke
  STROKE_COLOR: 'gd-stroke-color',
  STROKE_WIDTH: 'gd-stroke-width',
};
